import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { EnumService } from '../../../core/enum.service';
import { ModalService } from '../../../core/modal.service';

@Component({
  selector: 'app-step5',
  templateUrl: './step5.component.html'
})
export class Step5Component implements OnInit, OnChanges {
  @Input() product: any = {};
  @Input() productDetailMode: boolean;
  @Input() readonly = false;
  @ViewChild('form') form;
  vineyard: any[] = [];
  irrigation: any[] = [];
  column = 'uk-width-1-1';

  constructor(private enumService: EnumService, private modalService: ModalService) {}

  ngOnInit() {
    this.vineyard = this.enumService.getVineyardTypes();
    this.irrigation = this.enumService.getIrrigationTypes();
  }

  ngOnChanges() {
    if (this.productDetailMode) {
      this.column = 'uk-width-small-1-2';
    }
  }

  isValid() {
    return this.form.valid;
  }

  validate() {
    this.form.submitted = true;
    if (!this.isValid()) {
      this.modalService.showFormError();
      return false;
    }
    return true;
  }

  getData() {
    return this.product;
  }
}
